import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Firefox iOS: ignore transient "Script error" on input focus (user can interact after closing)
    if (error?.message === 'Script error.' && /Firefox|FxiOS/i.test(navigator.userAgent)) {
      return null;
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="chat-container">
          <div className="terminal-frame chat-frame">
            <div className="terminal-titlebar">XF - Personal IP Discovery Tool</div>
            <div className="terminal-content" style={{ padding: '1.5rem' }}>
              <div className="error-box">
                <p className="text-content">
                  <span className="text-error">error:</span> So sorry—something went wrong. Please refresh the page and try again. If it persists, email us at hello@xf.works.
                </p>
                <div className="onboarding-nav mt-4">
                  <div className="nav-buttons">
                    <button
                      type="button"
                      className="terminal-button"
                      onClick={() => window.location.reload()}
                    >
                      [refresh]
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
